import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PageHeader } from "@/pages/admin/AdminLayout";
import { errMsg, fmtDate, useApi } from "@/lib/api";

const LABELS = { admin: "Amministratore", member: "In attesa (nessun accesso)" };

export default function Users() {
  const api = useApi();
  const [data, setData] = useState(null);
  useEffect(() => {
    api("get", "/users").then(setData);
  }, [api]);

  const setRole = async (userId, role) => {
    try {
      await api("patch", `/users/${userId}/role`, { role });
      setData((d) => ({ ...d, users: d.users.map((u) => (u.user_id === userId ? { ...u, role } : u)) }));
      toast.success("Ruolo aggiornato");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  if (!data) return <Loader2 className="h-6 w-6 animate-spin text-slate-400" />;
  return (
    <div data-testid="admin-users-page">
      <PageHeader title="Utenti" subtitle="Chi accede con Google entra come 'In attesa' finché un amministratore non lo abilita" />
      <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white">
        <table data-testid="admin-users-table" className="w-full min-w-[600px] text-left text-sm">
          <thead className="border-b border-slate-200 bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
            <tr><th className="px-4 py-3 font-medium">Utente</th><th className="px-4 py-3 font-medium">Registrato</th><th className="px-4 py-3 font-medium">Ruolo</th></tr>
          </thead>
          <tbody>
            {data.users.map((u) => (
              <tr key={u.user_id} data-testid={`user-row-${u.user_id}`} className="border-b border-slate-100 last:border-0">
                <td className="px-4 py-3"><p className="font-medium">{u.name || "—"}</p><p className="text-xs text-slate-500">{u.email}</p></td>
                <td className="px-4 py-3 text-slate-500">{fmtDate(u.created_at)}</td>
                <td className="px-4 py-3">
                  <Select value={u.role} onValueChange={(r) => setRole(u.user_id, r)}>
                    <SelectTrigger data-testid={`user-role-select-${u.user_id}`} className="h-9 w-60 rounded-xl"><SelectValue /></SelectTrigger>
                    <SelectContent>{data.roles.map((r) => <SelectItem key={r} value={r}>{LABELS[r] || r}</SelectItem>)}</SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
